import apiCall from "../../../api";
export interface BankIDInitResponse {
  id: string;
  qrCode: string;
  autoStartToken: string;
  qrSession?: string;
}

export interface BankIDQrCodeResponse {
  statusCode: number;
  message: string;
  response?: { qrCode: string };
}

export interface BankIDAuthResponse {
  token?: string;
  message?: string;
  isLoginWithBankId?: boolean;
  userData?: any;
}

export const getBankIDDetails = async (): Promise<BankIDInitResponse> => {
  const response = await apiCall.get('/auth');
  return response.data.response;
};

export const initializeBankIDAuth = async (): Promise<BankIDInitResponse> => {
  const response = await apiCall.get('/auth');
  return response.data.response;
};

// BankID QR codes are animated: the backend returns the frame for the current second.
export const getBankIDQrCode = async (
  bankIdSession: string,
  qrSession: string
): Promise<BankIDQrCodeResponse> => {
  const response = await apiCall.get(
    `/auth/qr-code/${bankIdSession}?session=${encodeURIComponent(qrSession)}`
  );
  return response.data;
};

export const checkBankIDAuthStatus = async (
  bankIdSession: string,
  mode: 'login' | 'signup'
): Promise<BankIDAuthResponse> => {
  const endpoint = `/auth/collect-response/qr-code/${bankIdSession}`;
  
  let response;
  if (mode === 'signup') {
    response = await apiCall.post(endpoint);
  } else {
    response = await apiCall.get(endpoint);
  }
  
  return response.data;
};

export const openBankIDSameDevice = (
  bankDetails: { id: string; autoStartToken: string },
  options: {
    mode: 'login' | 'signup';
    accountType?: 'freelancer' | 'business';
    language?: string;
  }
): void => {
  const baseUrl = (import.meta as any).env.VITE_API_URL || 'https://api-prod.invozio.com/api';
  const redirectParams = new URLSearchParams({
    lang: options.language || 'sv-se',
  });

  if (options.mode === 'signup') {
    redirectParams.set('signup', 'true');
    if (options.accountType) {
      redirectParams.set('accountType', options.accountType === 'business' ? '2' : '1');
    }
  }

  const url1 = `${baseUrl}/auth/collect-response/${bankDetails.id}?${redirectParams.toString()}`;
  const encoded = encodeURIComponent(url1);
  const url = `https://app.bankid.com/?autostarttoken=${bankDetails.autoStartToken}&redirect=${encoded}`;
  
  window.open(url, '_blank');
};
